import { createContext, useContext, useMemo } from "react";

export interface RoutingContextState {
  routePrefix?: string;
}

export const RoutingContext = createContext<RoutingContextState>({});

export interface RoutingProviderProps {
  children: React.ReactNode;
  routePrefix?: string;
}

export function useRouting() {
  return useContext(RoutingContext);
}

export default function RoutingProvider(props: Readonly<RoutingProviderProps>) {
  const { children, routePrefix } = props;
  const value = useMemo(() => ({ routePrefix }), [routePrefix]);

  return (
    <RoutingContext.Provider value={value}>{children}</RoutingContext.Provider>
  );
}
